<template>
  <div v-if="course" class="chapter-page">
    <ChapterStats
      :style="safeTopVar"
      class="chapter-stat"
      :words="countWords"
      :ranking="getRank"
      :grammer="countLaws"
      :sentance="countSentences"
      :page="page"
      :changePage="changePage"
    />
    <!-- <div :style="safeTopVar" class="statsSafe"></div> -->
    <ChapterHeader
      :style="safeTopChap"
      class="chapter-head"
      v-if="page == 'main'"
      :title="
        courseChapter ? courseChapter.name : $t('chapter.chapter-page.loading')
      "
      :prev="prevChapter"
      :next="nextChapter"
    />

    <ChapterCourse
      v-if="page == 'main'"
      class="chapter-course"
      :course="courseChapter ? courseChapter : null"
      :id="id ? id : null"
      :progress="userProgress"
      :nextLesson="nextLesson"
      :permission="userPermission"
    />
    <ChapterCourseByType
      v-if="sortByType"
      class="chapter-course"
      :course="courseChapter ? courseChapter : null"
    />
    <SavedWords v-if="page == 'savedwords'" />
    <!-- <LeaderBoard v-if="page == 'leaderboard'" /> -->
    <Settings v-if="page == 'settings'" :permission="userPermission" />
    <Videos v-if="page == 'videos'" :permission="userPermission" />
    <Dictionary v-if="page == 'dictionary'" />
    <Externals
      v-if="page == 'grammar' || page == 'sentence'"
      :exType="page"
      :permission="userPermission"
      :changePage="changePage"
      @hideFooter="hideFooter"
      @showFooter="showFooter"
    />
    <ChapterBtn
      :style="safeBottomVarBtn"
      class="above-footer-fixed"
      v-if="page == 'savedwords' || page == 'main'"
      :nextLesson="nextLesson"
      :page="page"
      :user="user"
    />
    <ChapterFooter
      v-if="showfoot"
      :style="safeBottomVar"
      class="footer-fixed"
      :changePage="changePage"
      :page="page"
      :nextLesson="nextLesson"
    />
    <div :style="safeBottomVar" class="iosFooter"></div>
  </div>
</template>

<script>
import "./chapter-page.scss";
import ChapterHeader from "./chapter-header";
import ChapterStats from "./chapter-stats.vue";
import ChapterCourse from "./chapter-course.vue";
import ChapterFooter from "./chapter-footer.vue";
import Externals from "../Lesson/external-game.vue";
import ChapterBtn from "./chapter-btn.vue";
import ChapterCourseByType from "./chapter-course-by-types.vue";
import SavedWords from "../SavedWords/SavedWords.vue";
import LeaderBoard from "../LeaderBoard/LeaderBoard.vue";
import Settings from "../Settings/Settings.vue";
import Videos from "../Videos/Video.vue";
import Dictionary from "../Dictionary/Dictionary.vue";
import { userService } from "../../services/userService";

export default {
  name: "chapter-page",
  props: ["pageProp"],
  data() {
    return {
      page: "main",
      chapter: null,
      courseChapter: null,
      prevChapter: null,
      nextChapter: null,
      lawsProgress: 0,
      wordsProgress: 0,
      chapterProgress: 0,
      refresh: false,
      id: 0,
      chapterNum: 0,
      showfoot: true
    };
  },
  created() {
    const { id } = this.$route.params;
    this.id = id;

    this.calcChapterProgress();
    this.doRefresh();
  },
  mounted() {
    if (this.pageProp) this.page = this.pageProp;
  },
  computed: {
    sortByType() {
      if (this.$route.query.sort === "gametype") {
        return true;
      }
      return false;
    },
    chapters() {
      return this.$store.getters.chapters;
    },
    course() {
      this.refresh;

      return this.$store.getters.course;
    },
    user() {
      return this.$store.getters.user;
    },
    safeBottom() {
      return this.$store.getters.safeBottom;
    },
    safeBottomVar() {
      return { "--bottom": this.$store.getters.safeBottom + "px" };
    },
    safeTopVar() {
      return { "--top": this.$store.getters.safeTop + "px" };
    },
    safeTopChap() {
      return { "--topHead": this.$store.getters.safeTop + 64 + "px" };
    },
    safeBottomVarBtn() {
      return {
        "--bottomBtn": this.$store.getters.safeBottom + 58 + "px"
      };
    },
    userProgress() {
      if (this.user && this.user.lessons) {
        return this.user.lessons
          .filter(lesson => lesson.is_done === true)
          .map(les => les.lesson.id);
      } else if (!this.user && window.localStorage.getItem("progress")) {
        return JSON.parse(atob(window.localStorage.getItem("progress")));
      } else {
        return [];
      }
    },
    getRank() {
      if (this.user) {
        return this.user.user_rank;
      } else {
        return 0;
      }
    },
    countSentences() {
      if (this.user) {
        return this.user.sentences_score / 10;
      } else {
        return 0;
      }
    },
    countWords() {
      if (this.user && this.user.words_score) {
        return this.user.words_score;
      } else {
        return 0;
      }
    },
    countLaws() {
      if (this.user) {
        return this.user.rules_score / 5;
      } else {
        return 0;
      }
    },
    nextLesson() {
      if (this.course && this.userProgress) {
        let storedLesson = this.$store.getters.nextLesson;
        if (storedLesson.id) return storedLesson;
        let result = [];
        for (const chap of this.course) {
          for (let sec of chap.section) {
            for (let les of sec.lesson) {
              if (
                les.game &&
                les.game.permission !== "unknown" &&
                this.userPermission == "unknown"
              )
                continue;
              if (
                les.game &&
                les.game.permission === "paying" &&
                this.userPermission === "registered"
              ) {
                continue;
              }
              if (
                les.permission &&
                les.permission !== "unknown" &&
                this.userPermission == "unknown"
              )
                continue;
              if (
                les.permission &&
                les.permission === "paying" &&
                this.userPermission === "registered"
              ) {
                continue;
              }
              result.push({ ...les, chapter: chap.id });
            }
          }
        }

        for (let n of result) {
          if (!this.userProgress.includes(n.id)) {
            return n;
            break;
          }
        }
        return [];
      } else {
        return [];
      }
    },
    userPermission() {
      if (this.user && this.user.subscription_active) {
        return "paying";
      } else if (this.user && !this.user.subscription_active) {
        return "registered";
      } else {
        return "unknown";
      }
    }
  },
  methods: {
    doRefresh() {
      this.refresh = !this.refresh;
    },
    setGrammarProgress(progress) {
      this.lawsProgress = progress || 0;
    },
    setVocabularyProgress(progress) {
      this.wordsProgress = progress;
    },
    calcChapterProgress() {
      this.chapterProgress = (this.lawsProgress + this.wordsProgress) / 2 || 0;
    },
    hideFooter() {
      this.showfoot = false;
    },
    showFooter() {
      this.showfoot = true;
    },
    changePage(page) {
      if (page) {
        this.page = page;
      }
    }
  },
  watch: {
    $route(to, from) {
      // console.log("CHANGED PAGE");
      const { id } = to.params;
      this.chapter = this.chapters.find(c => c.id === id);
      this.chapterNum = this.course.length;
      //this.courseChapter = this.course.find(c => c.order === id);
      if (id <= this.chapterNum) {
        this.courseChapter = this.course[id - 1];
      }
      this.prevChapter = parseInt(id) - 1 > 0 ? parseInt(id) - 1 : null;

      this.nextChapter =
        parseInt(id) !== this.chapterNum && parseInt(id) < this.chapterNum
          ? parseInt(id) + 1
          : null;
    },
    chapters() {
      const { id } = this.$route.params;
      this.chapter = this.chapters.find(c => c.id === id);
    },
    course() {
      const { id } = this.$route.params;
      // this.courseChapter = this.course.find(c => c.order == id);
      this.chapterNum = this.course.length;
      if (id <= this.chapterNum) {
        this.courseChapter = this.course[id - 1];
      } else {
        // console.log("NO SUCH CHAPTER");
      }
      this.prevChapter = parseInt(id) - 1 > 0 ? parseInt(id) - 1 : null;

      this.nextChapter =
        parseInt(id) !== this.chapterNum && parseInt(id) < this.chapterNum
          ? parseInt(id) + 1
          : null;
    },
    wordsProgress() {
      this.calcChapterProgress();
    },
    lawsProgress() {
      this.calcChapterProgress();
    },
    pageProp() {
      if (this.pageProp) this.page = this.pageProp;
    },
    user() {
      this.countWords = this.user.saved_words.length
    }
  },
  components: {
    ChapterHeader,
    ChapterStats,
    ChapterFooter,
    ChapterCourse,
    Externals,

    ChapterBtn,
    ChapterCourseByType,
    SavedWords,
    LeaderBoard,
    Settings,
    Videos,
    Dictionary
  }
};
</script>

<style scoped>
.footer-fixed {
  bottom: var(--bottom);
}
.above-footer-fixed {
  bottom: var(--bottomBtn);
}
.chapter-stat {
  top: var(--top);
}
.chapter-head {
  top: var(--topHead);
}
.iosFooter {
  height: var(--bottom);
  background-color: var(--bg-primary);
  z-index: 1500;
  position: fixed;
  bottom: 0;
  width: 100%;
}
.statsSafe {
  /* top: var(--top);
  background-color: white;
  z-index: 55;
  position: absolute; */
  height: 52px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// chapter-page.vue?187a21b4